
import { useQuery } from 'react-query';

import { handleRefreshToken } from 'utils/refreshToken';
import { API_URL, HEADER_ACCEPT_HR } from 'utils/apiConstants';
import { FetchError } from 'utils/FetchError';
import { GetCompanyAdminsData, GetCompanyAdminsParams } from 'interfaces/hooks/permissionsHooksInterfaces';

export const useGetCompanyAdmins = ({ companyUuid, onError }: GetCompanyAdminsParams): GetCompanyAdminsData => {
  const { data: companyAdminsData } = useQuery(
    ['users_roles', companyUuid],
    async () => {
      await handleRefreshToken();

      const token = localStorage.getItem('token');

      const res = await fetch(`${API_URL}/company_roles/${companyUuid}/?role=hr_admin`, {
        method: 'GET',
        headers: {
          Accept: `${HEADER_ACCEPT_HR}`,
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.ok) {
        return res.json();
      }
      throw new FetchError(res);
    },
    {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      onError,
      enabled: !!companyUuid,
      select: (res) => res.data,
    }
  );

  return {
    companyAdminsData,
  };
};